export default __webpack_public_path__ + "static/media/verify.bb13014e.gif";